import { Page, Document, PDFViewer, Image } from "@react-pdf/renderer";
import * as dayjs from "dayjs";
import { Request } from "../../hooks/Request";
import { Circle } from "../../components/Animation";
import View from "../../components/GeneratePdf/View";
import Text from "../../components/GeneratePdf/Text";
import CustomTablePDF from "../../components/GeneratePdf/CustomTablePDF";
import logotipo from "../../assets/LogotipoTC.png";
import Logadex from "../../assets/Logadex.jpg";
import qrLogadex from "../../assets/qrLogadex.png";
import { numberWithDecimals, validateArray } from "../../utils/validate";
import FormDefault from "../../components/Forms/FormDefault";
import { H2, H3 } from "../../components/Text";
import { useDialog } from "../../contexts/DialogContext";
import { requestAuth } from "../../components/services/RequestService";
import { toast } from "react-toastify";

const listField = ["despachoRegularizado", "observacionesRegularización"];

const FormRegulation = (props) => {
  const { procedure, reload } = props;
  const { openDialog } = useDialog();
  const { data, loading } = Request({
    urlApi: `/procedure/${
      procedure.id || procedure.procedureId
    }/datasets?${listField.map((field) => `fieldnames=${field}`).join("&")}`,
    // fieldnames=tipoDeCambioProforma
    // &fieldnames=importacionN_º
    // &fieldnames=atención
    // &fieldnames=derechosYTributosDeImportación
    // &fieldnames=detallesDeLaLiquidación
  });

  console.log("🚀 ~ PdfProform ~ data:", data);
  if (!loading) {
    return <Circle />;
  }

  async function onSubmit(values, resetForm) {
    const result = await Promise.all(
      data.map(async (element) => {
        if (element.type === "file" || element.type === "fileRead") {
          if (
            (values[element.name] === "" || values[element.name] === null) &&
            (element.initial === "" || element.initial === null)
          ) {
            return null;
          } else if (
            (values[element.name] !== "" && !element.initial) ||
            (values[element.name] !== "" &&
              values[element.name] !== element.initial)
          ) {
            let formData = new FormData();
            formData.append("Name", element.name);
            formData.append("File", values[element.name]);
            formData.append("originalName", values[element.name].name);
            formData.append("Status", "verified");
            formData.append("ProcedureId", procedure.id);
            const fileContents = await requestAuth(
              "post",
              "/files",
              formData
            ).then((res) => {
              return {
                Value: res.data.url,
                ProcedureId: procedure.id,
                FieldId: element.id,
                FileId: res.data.id,
                name: element.name,
                url: element.url,
                type: element.type,
              };
            });
            return fileContents;
          } else {
            return {
              Value: element.initial,
              ProcedureId: procedure.id,
              FieldId: element.id,
              name: element.name,
              url: element.url,
              type: element.type,
            };
          }
        } else if (element.type === "selectNewOption") {
          if (values[element.name + "_isNew"]) {
            await handleCreateOption(
              values[element.name] || values[element.name] === 0
                ? values[element.name]
                : "",
              element.url
            );
          }
          return {
            Value:
              values[element.name] || values[element.name] === 0
                ? values[element.name]
                : "",
            ProcedureId: procedure.id,
            FieldId: element.id,
            name: element.name,
            url: element.url,
            type: element.type,
          };
        } else {
          return {
            Value:
              values[element.name] || values[element.name] === 0
                ? values[element.name]
                : "",
            ProcedureId: procedure.id,
            FieldId: element.id,
            name: element.name,
            url: element.url,
            type: element.type,
          };
        }
      })
    );
    if (procedure.category === "multiple") {
    } else {
      await submitDataset(
        result.filter((n) => n),
        resetForm,
        values.btnSecondary
      );
    }
  }

  async function handleCreateOption(value, dropdown) {
    await requestAuth("post", "/dropdown/option", {
      Name: value,
      DropdownListLabel: dropdown,
    });
  }

  async function submitDataset(values, resetForm, btnSecondary) {
    await requestAuth("post", "/dataset", values)
      .then(async () => {
        reload();
        // onClose();
        // resetForm();
        // openDialog(<PdfProformView procedure={procedure} />);
        toast.success("Envio exitoso");
      })
      .catch(() => {
        toast.error("Error en el envio");
      });
  }
  function dataIntialValues(list) {
    let aux = {};
    list?.forEach((element) => {
      aux = {
        ...aux,
        [element.name]:
          (element.initial === "false" ? false : element.initial) || "",
      };
    });
    return aux;
  }
  return (
    <div className="">
      <H2>Datos de regularizacion</H2>
      {validateArray(data) ? (
        <FormDefault
          fields={data
            .sort((a, b) => {
              const indexA = listField.indexOf(a.name);
              const indexB = listField.indexOf(b.name);
              return indexA - indexB;
            })
            .map((value, index) => ({
              ...value,
              id: procedure.id || procedure.procedureId,
              fieldId: value.id,
              labelCustom: (
                <>
                  <span className="font-bold text-green-600">{index + 1}.</span>{" "}
                  {value.label}
                </>
              ),
              label: value.label,
              labelCustom: (
                <>
                  <span className="text-green-600">{index + 1}.</span>{" "}
                  {value.label}
                </>
              ),
              name: value.name,
              validate: value.validate,
              lockEdition: value.lockEdition,
              placeholder: "Complete el campo",
              type: value.type === "fileRead" ? "file" : value.type,
              typeInput: value.type === "fileRead" ? "file" : value.type,
              initial: value.initial ? value.initial : null,
              urlApi: value.url
                ? value.url.includes("/")
                  ? value.url
                  : `/Dropdown/${value.url}/options`
                : "",
              urlInitial: value.url,
              value: "name",
              labelOption: "name",
              action: () => {},
              reload: () => {},
              step: 1,
            }))}
          initialValues={dataIntialValues(data)}
          validationSchema={null}
          onSubmit={async (values, resetForm) =>
            await onSubmit(values, resetForm, data)
          }
          buttonFixed={true}
          buttonSecondary={false}
          buttonName="Registrar"
        />
      ) : (
        <H3>NO SE TIENE NINGÚN FORMULARIO</H3>
      )}
    </div>
  );
};
export default FormRegulation;
